import React, { Fragment } from "react";
import YouTube from "react-youtube";

export function Video({ id }) {
  const youtubeOptions = {
    playerVars: {
      autoplay: 0,
      loop: 0,
      // list: "user_uploads",
      modestbranding: 1,
      rel: 0,
      controls: 1,
    },
  };

  return (
    <Fragment>
      <div className="flex items-center justify-center flex-wrap w-full relative">
        <div className="w-full relative z-20">
          <YouTube
            opts={youtubeOptions}
            videoId={id}
            containerClassName={"youtubeContainer"}
          />
        </div>
      </div>
    </Fragment>
  );
}
